// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_p4-0";
export var animationContainer = "_p4-1";
export var itemPrice = "_p4-a";
export var itemizedContent = "_p4-9";
export var itemizedHeader = "_p4-7";
export var itemizedRow = "_p4-8";
export var itemizedSection = "_p4-6";
export var modalContent = "_p4-2";
export var orderName = "_p4-3";
export var refundOption = "_p4-4";
export var refundOptionsContainer = "_p4-5";
export var shippingLabel = "_p4-b";
export var totalRow = "_p4-c";